<app-create-asin-header></app-create-asin-header>

<div class="land-bg" style="{{minHeight}}">

    <div class="container mb-4" style="{{minHeight2}}">
        <div style="padding: 50px 30px;">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="question-card">
                        <div>
                            <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M31.9043 54.463L57.7487 28.6187L52.6165 23.4865L31.9043 44.1986L21.4566 33.7509L16.3244 38.8831L31.9043 54.463ZM37.0365 74.2586C31.9654 74.2586 27.1998 73.2957 22.7397 71.3699C18.2796 69.4441 14.3999 66.8328 11.1006 63.536C7.8013 60.2367 5.18998 56.357 3.26663 51.8969C1.34327 47.4367 0.380374 42.6711 0.37793 37.6C0.37793 32.5289 1.34083 27.7633 3.26663 23.3032C5.19243 18.843 7.80374 14.9633 11.1006 11.6641C14.3999 8.36478 18.2796 5.75346 22.7397 3.83011C27.1998 1.90675 31.9654 0.94385 37.0365 0.941406C42.1077 0.941406 46.8733 1.90431 51.3334 3.83011C55.7935 5.75591 59.6732 8.36722 62.9725 11.6641C66.2718 14.9633 68.8843 18.843 70.8101 23.3032C72.7359 27.7633 73.6976 32.5289 73.6952 37.6C73.6952 42.6711 72.7323 47.4367 70.8065 51.8969C68.8807 56.357 66.2693 60.2367 62.9725 63.536C59.6732 66.8353 55.7935 69.4478 51.3334 71.3736C46.8733 73.2994 42.1077 74.2611 37.0365 74.2586Z" fill="#52BA4A"/>
                            </svg>
                        </div>

                        <br />

                        <p class="mb-2" style="font-size: 20px;color: #666">ASIN generated successfully</p>

                        <small class="mb-0" style="font-size: 15px;letter-spacing: 1px">Your ASIN is <b class="asin-div">{{asin_no}}</b></small>
                        <div style="height: 30px">
                            <p class="mb-2 text-success" style="font-size: 13px;" *ngIf="copySuccess">Text copied to clipboard!</p>
                        </div>
                        <button class="copy-asin" (click)="copyText(asin_no)">
                            <img style="width: 120px !important;" src="/assets/create-asin/copyASIN.svg" alt="button" />
                        </button>
                        <br>
                        <div class="button-section">
                            <button (click)="printIndividualAsinCard()">Download Card</button>
                            <button class="home-btn" (click)="goHome()">Back to Home</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
    <app-app-loader></app-app-loader>
</div>

